import { FC } from 'react';
import { SeparatorSlice } from '@/types';
import { useScreenWidth } from '@/hooks';
import styles from './components.module.scss';
import classNames from 'classnames';

const ImageSeparator: FC<SeparatorSlice> = slice => {
  const { width } = useScreenWidth();
  const { primary } = slice;

  const svgBackground = primary?.pattern_image?.url ?? '';
  const backgroundColor = primary?.background_color ?? undefined;
  const backgroundSize = primary?.background_size ?? 'cover';
  const backgroundPosition = `left ${primary.background_position || 'center'}`;
  const offset = primary?.vertical_offset ?? 0;
  const rotation = primary?.image_rotation ?? 0;
  const overlap = primary?.overlap_adjacent;
  const sendToTheBack = primary?.send_to_the_back;
  const isVerticalOffset = overlap === 'next' || overlap === 'previous';

  const aspectRatio = primary.pattern_image?.dimensions
    ? primary.pattern_image.dimensions.height /
      primary.pattern_image.dimensions.width
    : 1;

  const height = width * aspectRatio;

  const getMarginTop = () => {
    if (overlap === 'previous') {
      return `${-height + 1 + offset}px`;
    }

    if (overlap === 'next') {
      return `${offset ?? 0}px`;
    }
    return undefined;
  };

  const marginBottom = overlap === 'next' ? `-${height - 1}px` : undefined;

  const topOffset = isVerticalOffset ? undefined : `${offset ?? 0}px`;

  if (!primary?.active) {
    return null;
  }

  return (
    <section
      className={classNames(styles.separator, {
        ['spacing_bottom']: overlap === 'none' && slice?.primary?.margin_bottom,
      })}
      style={{
        minWidth: '100%',
        height: `${height}px`,
        backgroundColor,
        backgroundImage: `url(${svgBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize,
        backgroundPosition,
        position: 'relative',
        top: topOffset,
        left: '0px',
        right: '0px',
        marginTop: getMarginTop(),
        marginBottom: marginBottom,
        transform: `rotate(${rotation}deg)`,
        transformOrigin: 'center',
        zIndex: sendToTheBack ? 0 : 3,
      }}
    />
  );
};

export default ImageSeparator;
